import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {fadeInAnimation} from '../../animations/fade-in.animation';

@Component({
  selector: 'app-modal-create-service',
  templateUrl: './modal-create-service.component.html',
  styleUrls: ['./modal-create-service.component.scss'],
  animations: [fadeInAnimation]
})
export class ModalCreateServiceComponent implements OnInit {

  @Input() isVisibleModal: boolean;
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectOption: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
  }

  onEmitSelectOption(value): void {
    this.selectOption.emit(value);
  }

  onEmitCloseModal(event): void {
    this.closeModal.emit(true);
  }
}
